import * as actionlist from '../actions/indicationactions';
import moment from 'moment';
const state = {
    search: '',
    page: 0,    
};

const getters = {
    page: state => state.page,
    search: state => state.search,    
};

const actions = {
    [actionlist.INDICATIONLIST_SEARCH]: ({ commit }, search) => {
        commit(actionlist.INDICATIONLIST_SEARCH, search);
    },
    [actionlist.INDICATIONLIST_PAGE]: ({ commit }, page) => {
        commit(actionlist.INDICATIONLIST_PAGE, page);
    },    
};

const mutations = {
    [actionlist.INDICATIONLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [actionlist.INDICATIONLIST_PAGE]: (state, page) => {
        state.page = page;
    },    
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
